import { render, staticRenderFns } from "./OurPriceSection.vue?vue&type=template&id=aa9b229e&scoped=true&"
import script from "./OurPriceSection.vue?vue&type=script&lang=js&"
export * from "./OurPriceSection.vue?vue&type=script&lang=js&"
import style0 from "./OurPriceSection.vue?vue&type=style&index=0&id=aa9b229e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9b229e",
  null
  
)

export default component.exports